import React, { useEffect, useRef, useState } from 'react';
import './InfoHint.css';

interface InfoHintProps {
  text: string;
  className?: string;
}

export const InfoHint: React.FC<InfoHintProps> = ({ text, className = '' }) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (event: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <span className={`info-hint${className ? ` ${className}` : ''}`} ref={wrapRef}>
      <button
        type="button"
        className="info-hint__btn"
        aria-label="About this metric"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        i
      </button>
      {open && (
        <span className="info-hint__popover" role="tooltip">
          {text}
        </span>
      )}
    </span>
  );
};

/** Presentational “i” mark matching InfoHint button styling (non-interactive). */
export const InfoHintIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <span className={`info-hint__icon-mark${className ? ` ${className}` : ''}`} aria-hidden>
    i
  </span>
);

export default InfoHint;
